export async function sendEmail({ to, type, name }) {
  try {
    const response = await fetch("/api/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ to, type, name }),
    });
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Email send failed:", err);
    return { error: err.message };
  }
}